$('#after-registration-wrap .hs-popup.has-wizard-new').smartWizard({
    toolbarSettings: {
        toolbarPosition: 'bottom',
        toolbarButtonPosition: 'right',
        showNextButton: true,
        showPreviousButton: true,
        keyNavigation: false,
        anchorSettings: {
            markDoneStep: true, // add done css
            markAllPreviousStepsAsDone: true, // When a step selected by url hash, all previous steps are marked done
            removeDoneStepOnNavigateBack: true, // While navigate back done step after active step will be cleared
            enableAnchorOnDoneStep: true // Enable/Disable the done steps navigation
        },
        toolbarExtraButtons: [
            $('<button></button>').text('Finish')
                .addClass('btn btn-finish')
                .on('click', function () {

                    // Add action for when user finishs the form

                }),
        ]
    },
    useURLhash: false,
    showStepURLhash: false,
    backButtonSupport: false,
    lang: {
        next: 'Save and Continue',
        previous: 'Back'
    }
});
if ($("#after-registration-wrap .hs-popup.has-wizard-new #step-1").is(":visible")) {
    $(".sw-btn-prev").addClass("disabled");
} else {
    $(".sw-btn-prev").removeClass("disabled");
}
if ($(".sw-container .step-content:last-child").is(":visible")) {
    $(".btn-finish").removeClass("disabled");
    $(".sw-btn-prev").addClass("disabled");
} else {
    $(".btn-finish").addClass("disabled");
    $(".sw-btn-prev").removeClass("disabled");
}

// $("#after-registration-wrap .hs-popup.has-wizard-new form .form-section").each(function () {
//     $(this).validator({
//         focus: false,
//     });
// })

// function preventJump(error = false){
//     setTimeout(function() {
//         var menuHeight = $("header").height();
//
//         if(error)
//             var scrollTo = $("#after-registration-wrap .hs-popup.has-wizard-new .has-error").first().offset().top - menuHeight - 30;
//         else
//             var scrollTo = $("#after-registration-wrap .hs-popup.has-wizard-new").offset().top - menuHeight - 30;
//
//         $("body,html").animate({scrollTop: scrollTo},100);
//
//     }, 1);
// }

// $("#after-registration-wrap .hs-popup.has-wizard-new").on("leaveStep", function (e, anchorObject, stepNumber, stepDirection) {
//     var elmForm = $("#after-registration-wrap .hs-popup.has-wizard-new #step-" + (stepNumber + 1) + " .form-section");
//     // stepDirection === 'forward' :- this condition allows to do the form validation
//     // only on forward navigation, that makes easy navigation on backwards still do the validation when going next
//     if (stepDirection === 'forward' && elmForm) {
//
//         elmForm.validator('validate');
//         var elmErr = elmForm.children('.has-error');
//         if (elmErr && elmErr.length > 0) {
//             // Form validation failed - jump to first error field
//             preventJump(true);
//             return false;
//         }
//         preventJump();
//     }
//     preventJump();
//     return true;
// });

// $("#after-registration-wrap .hs-popup.has-wizard-new").on("showStep", function (e, anchorObject, stepNumber, stepDirection) {
//     // Enable finish button only on last step
//     if (stepNumber == 4) {
//         $('.btn-finish').removeClass('disabled');
//         $(".sw-btn-prev").addClass("disabled force-disabled");
//         $(".step-anchor li.nav-item").addClass("disabled");
//     } else {
//         $('.btn-finish').addClass('disabled');
//         $(".sw-btn-prev").removeClass("disabled force-disabled");
//         $(".step-anchor li.nav-item").removeClass("disabled");
//     }
//     if (stepNumber == 0) {
//         $(".sw-btn-prev").addClass("disabled");
//     } else {
//         $(".sw-btn-prev").removeClass("disabled");
//     }
// });
